import { FC } from "react";
import {
  Box,
  Container,
  Typography,
  Divider,
} from "@mui/material";

import { ContactForm } from "../../components/HomePage/ContactForm/ContactForm";

export const AirbnbContactUsPage: FC = () => {
  return (
    <Box sx={{ bgcolor: "#f9fafb", color: "#1a1a1a", minHeight: "100vh", py: 8 }}>
      <Container maxWidth="md">
        {/* Title */}
        <Typography
          variant="h2"
          fontWeight={700}
          align="center"
          gutterBottom
          sx={{ mb: 4, fontSize: { xs: "2rem", md: "3rem" } }}
        >
          Contact Us
        </Typography>

        {/* Introduction */}
        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          We’re here to help you with your property rental needs. Whether you have questions, need assistance, or want to explore a partnership, our family is ready to listen. Fill out the form below, and we’ll get back to you—usually the same day, always with a personal touch.
        </Typography>

        <Divider sx={{ my: 4 }} />

        {/* Form Section */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            variant="h4"
            fontWeight={600}
            gutterBottom
            sx={{ mb: 3 }}
          >
            Get in Touch
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4, maxWidth: 600, mx: "auto" }}
          >
            Share your details and let us know how we can assist. We’re excited to connect and make your rental experience seamless.
          </Typography>
          <ContactForm />
        </Box>

        <Divider sx={{ my: 4 }} />
      </Container>
    </Box>
  );
};
